import {
  faArrowAltCircleDown,
  faCheck,
  faPen,
  faPlus,
  faTimes,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import EmptyList from 'components/common/EmptyList'; // Importe o EmptyList
import FalconComponentCard from 'components/common/FalconComponentCard';
import Flex from 'components/common/Flex';
import ServiceCatalogEditModal from 'components/modals/ServiceCatalogEditModal';
import ServiceCatalogImportModal from 'components/modals/ServiceCatalogImportModal';
import ServiceCatalogRegistrationModal from 'components/modals/ServiceCatalogRegistrationModal';
import Pagination from 'components/pagination';
import FailedRequest from 'components/requests-response/FailedRequest';
import SuccessRequest from 'components/requests-response/SuccessRequest';
import useApi from 'helpers/api';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useEffect, useState } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import ServiceCatalogService from 'services/ServiceCatalog.service';

const ServiceCatalogRegistration = () => {
  const api = useApi();
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const [selectedServiceCatalog, setSelectedServiceCatalog] = useState({});
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [error, setError] = useState({});
  const [success, setSuccess] = useState('');
  const [serviceCatalogs, setServiceCatalogs] = useState({
    content: [],
    totalElements: 0
  });
  const [filters, setFilters] = useState({
    page: 0,
    size: 20,
    includeInactives: 'false'
  });

  const isEmpty = !isLoading && serviceCatalogs.content.length === 0;

  const getData = async () => {
    setIsLoading(true);
    const queryParams = new URLSearchParams(filters).toString();

    try {
      const response = await ServiceCatalogService.list(queryParams);
      if (response.content) {
        setServiceCatalogs(response);
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [filters]);

  const columns = [
    {
      accessorKey: 'name',
      header: 'Nome',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: rowData => {
        const { id, name } = rowData.row.original;
        return (
          <Flex alignItems="center" gap={2}>
            <Link to={`/settings/services-catalog/${id}`}>{name}</Link>
          </Flex>
        );
      }
    },
    {
      accessorKey: 'serviceGroups',
      header: 'Grupos de serviço',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: rowData => {
        const { serviceGroups } = rowData.row.original;
        return (
          <Flex alignItems="center">
            <FontAwesomeIcon icon={faUsers} className="me-1" />
            {serviceGroups.map((item, index) => (
              <span key={index}>
                {item.name}
                {index !== serviceGroups.length - 1 && ', '}
              </span>
            ))}
          </Flex>
        );
      }
    },
    {
      accessorKey: 'inactive',
      header: 'Status',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: rowData => {
        const { inactive } = rowData.row.original;
        return inactive ? (
          <span className="text-danger">
            <FontAwesomeIcon icon={faTimes} />
          </span>
        ) : (
          <span className="text-success">
            <FontAwesomeIcon icon={faCheck} />
          </span>
        );
      }
    },
    {
      accessorKey: 'actions',
      header: 'Ações',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: rowData => {
        const item = rowData.row.original;
        return (
          <button
            className="btn btn-link btn-sm"
            onClick={() => handleEdit(item)}
          >
            <FontAwesomeIcon icon={faPen} size="sm" />
          </button>
        );
      }
    }
  ];

  const table = useAdvanceTable({
    data: serviceCatalogs.content,
    columns
  });

  const handleCloseModalRegister = () => {
    setShowModal(false);
  };

  const handleCloseModalEdit = () => {
    setShowModalEdit(false);
  };

  const handleEdit = item => {
    setSelectedServiceCatalog(item);
    setShowModalEdit(true);
  };

  const createServiceCatalog = async body => {
    const response = await ServiceCatalogService.create(body);
    if (response.status) {
      setError(response);
      setShowAlertError(true);
    } else {
      getData();
      setSuccess('Catálogo criado com sucesso');
      setShowAlert(true);
    }
    handleCloseModalRegister();
  };

  const editServiceCatalog = async bodyChange => {
    const response = await ServiceCatalogService.edit(
      selectedServiceCatalog.id,
      bodyChange
    );
    if (response.status) {
      setError(response);
      setShowAlertError(true);
    } else {
      getData();
      setSuccess('Catálogo editado com sucesso');
      setShowAlert(true);
    }
    handleCloseModalEdit();
  };

  const handleFilterChange = value => {
    setFilters(prevFilters => ({
      ...prevFilters,
      includeInactives: value,
      page: 0
    }));
  };

  return (
    <>
      <ServiceCatalogImportModal
        show={showImportModal}
        handleClose={() => setShowImportModal(false)}
        refresh={() => getData()}
      />
      <SuccessRequest
        message={success}
        showAlert={showAlert}
        setShowAlert={() => setShowAlert(false)}
      />
      <FailedRequest
        message={error.description}
        showAlert={showAlertError}
        setShowAlert={() => setShowAlertError(false)}
      />
      <FalconComponentCard>
        <FalconComponentCard.Header title="Catálogos de serviços">
          <div className="w-100 d-flex justify-content-between">
            <Button
              variant="primary"
              size="sm"
              className="me-2"
              onClick={() => setShowImportModal(true)}
            >
              <FontAwesomeIcon
                icon={faArrowAltCircleDown}
                size="sm"
                className="me-2"
              />
              Importar
            </Button>

            <Button
              variant="primary"
              size="sm"
              onClick={() => setShowModal(true)}
            >
              <FontAwesomeIcon icon={faPlus} size="sm" className="me-2" />
              Novo
            </Button>
          </div>
        </FalconComponentCard.Header>
        <FalconComponentCard.Body>
          <Flex justifyContent={'end'}>
            <Col className="col-auto px-3">
              <Form.Select
                size="sm"
                className="mb-3 rounded-pill"
                value={filters.includeInactives}
                onChange={e => handleFilterChange(e.target.value)}
              >
                <option value="false">Filtro por status</option>
                <option value="true">Todos</option>
                <option value="false">Somente ativos</option>
              </Form.Select>
            </Col>
          </Flex>

          <ServiceCatalogEditModal
            showModal={showModalEdit}
            data={selectedServiceCatalog}
            handleClose={handleCloseModalEdit}
            handleSubmit={editServiceCatalog}
            refreshData={() => getData()}
            error={error => setError(error)}
          />
          <ServiceCatalogRegistrationModal
            showModal={showModal}
            handleClose={handleCloseModalRegister}
            handleSubmit={createServiceCatalog}
          />

          {isLoading ? (
            <Skeleton count={10} height={44} baseColor="#5E6E82" />
          ) : isEmpty ? (
            <div style={{ minHeight: '300px' }}>
              <EmptyList imgSize={500} vhSize={73} />
            </div>
          ) : (
            <>
              <AdvanceTableProvider {...table}>
                <AdvanceTable
                  table
                  headerClassName="text-nowrap align-middle"
                  rowClassName="align-middle white-space-nowrap"
                  tableProps={{
                    striped: true,
                    className: 'fs-10 mb-0 overflow-hidden'
                  }}
                />
              </AdvanceTableProvider>
              <Pagination
                data={serviceCatalogs}
                filters={filters}
                setFilters={setFilters}
              />
            </>
          )}
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </>
  );
};

export default ServiceCatalogRegistration;
